// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#operations-pin_svg__a)">
      <mask
        id="operations-pin_svg__b"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M24 24H0V0h24z"
        />
      </mask>
      <g mask="url(#operations-pin_svg__b)">
        <path
          fill="currentColor"
          d="m14.243 6.929-3.535 3.535a4.943 4.943 0 0 1-2.829 1.415l4.243 4.242a4.985 4.985 0 0 1 1.414-2.828l3.536-3.536zm6.364 4.95a1.003 1.003 0 0 1-1.414 0l-.707-.707-3.536 3.535a2.996 2.996 0 0 0-.578 3.433c.241.496.262 1.126-.129 1.517a1 1 0 0 1-1.414 0L9.272 16.1l-4.657 4.657a1 1 0 0 1-1.414-1.414l4.657-4.657-3.514-3.514a1 1 0 0 1 0-1.415c.39-.39 1.02-.37 1.517-.128a2.996 2.996 0 0 0 3.432-.579l3.536-3.535-.707-.707a1.003 1.003 0 0 1 0-1.415 1.003 1.003 0 0 1 1.414 0l7.071 7.072a1.003 1.003 0 0 1 0 1.414z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="operations-pin_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOperationsPin;
